import { render } from "./BaseDashboardContainer.vue?vue&type=template&id=5ffa3ee2"
import script from "./BaseDashboardContainer.vue?vue&type=script&lang=js"
export * from "./BaseDashboardContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__